<template>
  <span>
    <!-- if more than 3 seats, show expandable/collapsable ui -->
    <span v-if="hasMoreThanThreeSeats">
      <div class="pl-2" v-for="(spot) in firstThreeSeats" :key="spot.id">
        <SeatDetails
          :selectedContractName="spot.priceName"
          :availableAt="spot.availableDate"
          :cost="spot.costAmount"
          :costFrequency="spot.costFrequency"
          :daysPerWeek="spot.daysPerWeek"
          :daysOfWeek="spot.daysOfWeekDisplay"
          :hoursFromTo="spot.hoursFromTo"
          :createdAt="spot.created_at"
          :legupId="spot.legup_seat_id"
          :offerNotes="spot.offerNotes"
        />
      </div>
      <div class="pt-1" v-if="!shouldShowAllSeats">
        <a href="#" @click.prevent="showAllSpots">
          Show all spots ({{spots.length}}) <span class="fal fa-angle-down"></span>
        </a>
      </div>

      <div v-if="shouldShowAllSeats">
        <div class="pl-2" v-for="(spot) in remainingSeats" :key="spot.id">
          <SeatDetails
            :selectedContractName="spot.priceName"
            :availableAt="spot.availableDate"
            :cost="spot.costAmount"
            :costFrequency="spot.costFrequency"
            :daysPerWeek="spot.daysPerWeek"
            :daysOfWeek="spot.daysOfWeekDisplay"
            :hoursFromTo="spot.hoursFromTo"
            :createdAt="spot.created_at"
            :legupId="spot.legup_seat_id"
            :offerNotes="spot.offerNotes"
          />
        </div>
        <div class="pt-1">
          <a href="#" @click.prevent="showFewerSpots">
            Show fewer spots <span class="fal fa-angle-up"></span>
          </a>
        </div>
      </div>
    </span>

    <!-- if 3 or fewer, just render those seats -->
    <div class="pl-2" v-for="(spot) in spots" :key="spot.id" v-else>
      <SeatDetails
        :selectedContractName="spot.priceName"
        :availableAt="spot.availableDate"
        :cost="spot.costAmount"
        :costFrequency="spot.costFrequency"
        :daysPerWeek="spot.daysPerWeek"
        :daysOfWeek="spot.daysOfWeekDisplay"
        :hoursFromTo="spot.hoursFromTo"
        :createdAt="spot.created_at"
        :legupId="spot.legup_seat_id"
        :offerNotes="spot.offerNotes"
      />
    </div>
  </span>
</template>

<script>
import SeatDetails from './seat-details.vue';

export default {
  name: 'expandable-spot-list',
  components: {
    SeatDetails,
  },
  props: {
    spots: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      shouldShowAllSeats: false,
    };
  },
  computed: {
    firstThreeSeats() {
      return this.spots.slice(0, 3);
    },
    remainingSeats() {
      return this.spots.slice(3);
    },
    hasMoreThanThreeSeats() {
      return this.spots.length > 3;
    },
  },
  methods: {
    showAllSpots() {
      this.shouldShowAllSeats = true;
    },
    showFewerSpots() {
      this.shouldShowAllSeats = false;
    },
  },
};
</script>
<style scoped>
a {
  color: var(--viridian-50) !important;
  font-weight: 400;
  font-size: 16px;
  transition: color 0.2s ease;
  cursor: pointer;
}

a:hover {
  color: var(--teal-60);
  text-decoration: none;
}

.fal {
  margin-left: 4px;
}
</style>
